import React, { Component } from "react";

export default class SayHello extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div>Hello From the Common UI Component !!</div>
      </div>
    );
  }
}
